var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAdminA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.25,
    height: 28.25
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-admin-A_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 39",
    d: "M25.5 26.75H.5A1.252 1.252 0 01-.75 25.5V.5A1.252 1.252 0 01.5-.75h25A1.252 1.252 0 0126.75.5v25a1.252 1.252 0 01-1.25 1.25zm-8-13a2.75 2.75 0 102.75 2.75 2.753 2.753 0 00-2.75-2.75zm-9-6a2.75 2.75 0 102.75 2.75A2.753 2.753 0 008.5 7.75z",
    transform: "translate(4841 2142)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2185"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 357",
    transform: "translate(1.75 1.75)",
    fill: "none",
    stroke: "#00b8f1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.75,
    width: 26.5,
    height: 26.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 14",
    clipPath: "url(#icon-admin-A_svg__a)",
    transform: "translate(-4840.25 -2141.25)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2152",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 165",
    d: "M4849.5 2147.5v16"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 166",
    d: "M4858.5 2147.5v16"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 94",
    transform: "translate(5.75 7.75)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 2.75
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 95",
    transform: "translate(14.75 13.75)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 2.75
  })))));
}

export default SvgIconAdminA;